import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import DoctorRow from "./DoctorRow";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import MessageBar from "../../shared/pages/messageBar";
import Stack from "@mui/material/Stack";
import { useSnackbar } from "notistack";
import { baseUrl } from "../../baseUrl";

const DoctorsTable = (props) => {
  const dispatch = useDispatch();
  const updater = useSelector((state) => state.updateReducer.doctorTable);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState();
  const auth = useContext(AuthContext);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [doctors, setDoctors] = useState();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleChange = (event, value) => {
    setPage(value);
  };
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-doctors`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              page: page,
              onlyName: false,
              // rowCount: 4,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setDoctors(responseData.data.result);
        setTotal(responseData.data.totalItem);
      } catch (err) {
        err &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
      setIsLoading(false);
    }

    sendRequest();
  }, [page, updater]);
  const pageCount = Math.ceil(total / 4);
  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <TableContainer sx={{ p: 2, mt: 2 }} aria-label="simple table">
        {doctors && (
          <Table>
            <>
              {" "}
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell align="center">نام پزشک</TableCell>
                  <TableCell align="center">شماره تماس</TableCell>
                  <TableCell align="center">ایمیل</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {doctors.map((doctor) => {
                  return (
                    <DoctorRow
                      key={doctor.id}
                      id={doctor.id}
                      name={doctor.name}
                      contactNumber={doctor.contactNumber}
                      email={doctor.email}
                      address={doctor.address}
                      token={doctor.doctorToken}
                    />
                  );
                })}
              </TableBody>
            </>
          </Table>
        )}
      </TableContainer>
      <Pagination
        sx={{ mt: 4, justifyContent: "center", display: "flex" }}
        count={pageCount}
        // page={page}
        onChange={handleChange}
      />
    </React.Fragment>
  );
};

export default DoctorsTable;
